import { render, staticRenderFns } from "./roleCreate.vue?vue&type=template&id=53cccd3b&"
import script from "./roleCreate.vue?vue&type=script&lang=js&"
export * from "./roleCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports